<template>
    <div id="transmission-details-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Transmission Details</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="font-weight-bold">Document(s):</div>
                    <template v-if="transmission">
                        <div v-for="document in transmission.documents" :key="'transmission-' + transmission.id + '-document-' + document.id" class="pl-3 text-truncate" :title="document.document_type.name + ' - ' + document.description ">
                            {{ document.document_type.name }} - {{ document.description }}
                        </div>
                    </template>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" data-dismiss="modal">Close</button> 
                </div>
            </div>
        </div>
    </div>                    
</template>

<script>
export default {
    data() {
        return {
            transmission: null
        }
    },
    methods: {
        show: function (transmission) {
            this.transmission = transmission;
            $('#transmission-details-modal').modal('show');
        }
    },
    created() {
        eventHub.$on('show-transmission-details', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-transmission-details');
    },
    
}
</script>

<style scoped>

</style>